import React from 'react';
import { Dialog as BaseDialog, DialogContent } from '@material-ui/core';
import PropTypes from 'prop-types';

const Dialog = (props) => {
  return (
    <BaseDialog open={props.open} aria-labelledby="form-dialog-title">
      <DialogContent>{props.children}</DialogContent>
    </BaseDialog>
  );
};

Dialog.propTypes = {
  open: PropTypes.bool,
  children: PropTypes.node,
};

export default Dialog;
